import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";
import Home from "@/views/Home.vue";
import DataCalonPeserta from "@/views/DataCalonPeserta.vue";
import NotFound from "@/views/NotFound.vue";
import Maintenance from "@/views/Maintenance.vue";
import Sign from "@/views/Sign.vue";
import Announcement from "@/views/Announcement.vue";
import Activation from "@/views/Activation.vue";
import ProgramRegistration from "@/views/ProgramRegistration.vue";
import RegistrationClosed from "@/views/RegistrationClosed.vue";
import Forbidden from "@/views/Forbidden.vue";
import Transaction from "@/views/Transaction.vue";
import StudentSchedule from "@/views/StudentSchedule.vue";
import TeacherSchedule from "@/views/TeacherSchedule.vue";
import TeacherReport from "@/views/TeacherReport.vue";
import StudentReport from "@/views/StudentReport.vue";
import SurveyForm from "@/views/SurveyForm.vue";
import DecisionForm from "@/views/DecisionForm.vue";
import DownloadReportPage from "@/views/DownloadReportPage.vue";
import ReferralNamesForm from "@/views/ReferralNamesForm.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "*",
    name: "NotFound",
    component: NotFound,
  },
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/sign/:indicator",
    name: "Sign",
    component: Sign,
  },
  {
    path: "/about",
    name: "About",
    component: Maintenance,
  },
  {
    path: "/program",
    name: "Program",
    component: Maintenance,
  },
  {
    path: "/announcement",
    name: "pengumuman",
    component: Announcement,
  },
  {
    path: "/transaction",
    name: "Transaction",
    component: Transaction,
  },
  {
    path: "/activate/:uid/:token",
    name: "Activation",
    component: Activation,
  },
  {
    path: "/program-registration",
    name: "Program Registration",
    component: ProgramRegistration,
  },
  {
    path: "/regis-closed",
    name: "RegistrationClosed",
    component: RegistrationClosed,
  },
  {
    path: "/data-calon-peserta",
    name: "DataCalonPeserta",
    component: DataCalonPeserta,
  },
  {
    path: "/forbidden/:indicator",
    name: "Forbidden",
    component: Forbidden,
  },
  {
    path: "/student-schedule",
    name: "StudentSchedule",
    component: StudentSchedule,
  },
  {
    path: "/teacher-schedule",
    name: "TeacherSchedule",
    component: TeacherSchedule,
  },
  {
    path: "/teacher-report",
    name: "TeacherReport",
    component: TeacherReport,
  },
  {
    path: "/student-report",
    name: "StudentReport",
    component: StudentReport,
  },
  {
    path: "/survey-form",
    name: "SurveyForm",
    component: SurveyForm,
  },
  {
    path: "/decision-form",
    name: "DecisionForm",
    component: DecisionForm,
  },
  {
    path: "/download-report",
    name: "DownloadReportPage",
    component: DownloadReportPage,
  },
  {
    path: "/referral-form",
    name: "ReferralNamesForm",
    component: ReferralNamesForm,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

// eslint-disable-next-line
router.beforeResolve((to, from, next) => {
  if (to.name) {
    store.commit("loadingStart");
  }
  next();
});

// eslint-disable-next-line
router.afterEach((to, from) => {
  setTimeout(() => {
    store.commit("loadingEnd");
  }, 3000);
});

export default router;
